// extracted by mini-css-extract-plugin
export default {"video":"LoginVideo_video__M+R4w"};